export default "__VITE_ASSET__cmUkP841__"